import { initEnvironment } from '../../../libs/config/init';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { deleteFromStore, getFromStore, openDB } from '../../../libs/authentication/indexeddb';
import { CurafidaSession } from '../../../libs/authentication/curafida-session';

/**
 * Migrates session tokens from IndexedDB to local storage.
 *
 * TODO: This function is only needed until all users have updated and migrated to local storage.
 * Once all users have migrated (after sufficient time/app versions), this function can be safely deleted.
 */
async function migrateIndexeddbSessionsToLocalStorage(): Promise<void> {
    let db: IDBDatabase | null = null;

    const ionicDbName = '_ionicstorage';
    const ionicStoreName = '_ionickv';
    const sessionKey = 'session';

    const accessTokenKey = 'access_token';
    const refreshTokenKey = 'refresh_token';

    const migrationCompletedKey = 'indexeddb_migration_completed';
    try {
        /* Check if migration was already completed */
        if (localStorage.getItem(migrationCompletedKey)) return;

        // eslint-disable-next-line no-console
        console.log('migrate session from indexeddb to localstorage');
        db = await openDB(ionicDbName);
        const session: CurafidaSession = await getFromStore(db, ionicStoreName, sessionKey);

        /* If no session exists in IndexedDB, mark migration as completed and skip */
        if (!session) {
            localStorage.setItem(migrationCompletedKey, 'true');
            return;
        }

        /* Migrate access and refresh tokens, but only if they are not already present */
        if (session?.tokenSet?.access_token && !localStorage.getItem(accessTokenKey)) {
            localStorage.setItem(accessTokenKey, session.tokenSet.access_token);
        }
        if (session?.tokenSet?.refresh_token && !localStorage.getItem(refreshTokenKey)) {
            localStorage.setItem(refreshTokenKey, session.tokenSet.refresh_token);
        }

        /* Migration done, delete old session and mark migration as completed */
        await deleteFromStore(db, ionicStoreName, sessionKey);
        localStorage.setItem(migrationCompletedKey, 'true');
        // eslint-disable-next-line no-console
        console.log('indexeddb session cleaned up after successful migration');
    } catch (err) {
        console.warn((err as Error).message);
    } finally {
        /* Always close the database connection */
        db?.close();
    }
}

(async () => {
    await migrateIndexeddbSessionsToLocalStorage();
    await initEnvironment(environment);
    await bootstrapApplication(AppComponent, appConfig);
})();
